import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import countries from '../../../utils/countries';
import provincesCanada from '../../../utils/provincesCanada';
import citiesCanada from '../../../utils/citiesCanada';

export const useRegisterForm = () => {
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        dateOfBirthString: '',
        /*gender: 'MALE',*/
        profession: '',
        streetAddress: '',
        neighborhood: '',
        country: 'Canada',
        city: '',
        province: '',
        username: '',
        password: '',
        confirmPassword: '',
        additionalInfos: '',
        enabled: true,
        roleNames: ['USER']
    });

    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});

    // Validation du mot de passe (simplifiée)
    const validatePassword = useCallback((password) => {
        if (!password) return 'Le mot de passe est requis';
        if (password.length < 5) return 'Le mot de passe doit contenir au moins 5 caractères';
        return '';
    }, []);

    // Validation des champs
    /*const validateField = useCallback((name, value) => {
        switch (name) {
            case 'firstName':
                return !value ? 'Le prénom est requis' : '';
            case 'lastName':
                return !value ? 'Le nom est requis' : '';
            case 'email':
                if (!value) return 'L\'email est requis';
                if (/\s/.test(value)) return 'L\'email ne doit pas contenir d\'espaces';
                if (!/\S+@\S+\.\S+/.test(value)) return 'Format d\'email invalide';
                return '';
            case 'phoneNumber':
                return !value || value.length < 10 ? 'Le numéro de téléphone est requis et doit être valide' : '';
            case 'dateOfBirthString':
                return !value ? 'La date de naissance est requise' : '';
            case 'username':
                if (!value) return 'Le nom d\'utilisateur est requis';
                if (/\s/.test(value)) return 'Le nom d\'utilisateur ne doit pas contenir d\'espaces';
                if (value.length < 4) return 'Le nom d\'utilisateur doit contenir au moins 4 caractères';
                return '';
            case 'password':
                return validatePassword(value);
            case 'confirmPassword':
                return !value ? 'La confirmation du mot de passe est requise' :
                    value !== formData.password ? 'Les mots de passe ne correspondent pas' : '';
            case 'streetAddress':
                return !value ? 'L\'adresse est requise' : '';
            case 'city':
                return !value ? 'La ville est requise' : '';
            case 'province':
                return !value ? 'La province est requise' : '';
            case 'country':
                return !value ? 'Le pays est requis' : '';
            default:
                return '';
        }
    }, [formData.password, validatePassword]);
*/



    const validateField = useCallback((name, value) => {
        switch (name) {
            case 'firstName':
                return !value ? 'Le prénom est requis' : '';
            case 'lastName':
                return !value ? 'Le nom est requis' : '';
            case 'email':
                if (!value) return 'L\'email est requis';
                if (/\s/.test(value)) return 'L\'email ne doit pas contenir d\'espaces';
                if (!/\S+@\S+\.\S+/.test(value)) return 'Format d\'email invalide';
                return '';
            case 'phoneNumber':
                return !value || value.length < 10 ? 'Le numéro de téléphone est requis et doit être valide' : '';
            case 'dateOfBirthString':
                return !value ? 'La date de naissance est requise' : '';
            case 'profession':  // Ajoutez ce cas
                return !value ? 'La profession est requise' : '';
            case 'username':
                if (!value) return 'Le nom d\'utilisateur est requis';
                if (/\s/.test(value)) return 'Le nom d\'utilisateur ne doit pas contenir d\'espaces';
                if (value.length < 4) return 'Le nom d\'utilisateur doit contenir au moins 4 caractères';
                return '';
            case 'password':
                return validatePassword(value);
            case 'confirmPassword':
                return !value ? 'La confirmation du mot de passe est requise' :
                    value !== formData.password ? 'Les mots de passe ne correspondent pas' : '';
            case 'streetAddress':
                return !value ? 'L\'adresse est requise' : '';
            case 'city':
                return !value ? 'La ville est requise' : '';
            case 'province':
                return !value ? 'La province est requise' : '';
            case 'country':
                return !value ? 'Le pays est requis' : '';
            default:
                return '';
        }
    }, [formData.password, validatePassword]);




    // Gestion des changements de saisie
    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        setTouched(prev => ({
            ...prev,
            [name]: true
        }));

        if (name === 'province') {
            setFormData(prev => ({
                ...prev,
                city: ''
            }));
        }

        const error = validateField(name, value);
        setErrors(prev => ({
            ...prev,
            [name]: error
        }));
    }, [validateField]);

    // Gestion du changement de numéro de téléphone
    const handlePhoneChange = useCallback((value) => {
        setFormData(prev => ({
            ...prev,
            phoneNumber: value
        }));

        setTouched(prev => ({
            ...prev,
            phoneNumber: true
        }));

        const error = validateField('phoneNumber', value);
        setErrors(prev => ({
            ...prev,
            phoneNumber: error
        }));
    }, [validateField]);

    // Validation de l'étape actuelle
    /*const isStepValid = useCallback((step) => {
        const fieldsToValidate = {
            0: ['firstName', 'lastName', 'email', 'phoneNumber', 'dateOfBirthString'],
            1: ['country', 'streetAddress', 'province', 'city'],
            2: ['username', 'password', 'confirmPassword']
        };

        return fieldsToValidate[step].every(field => {
            const error = validateField(field, formData[field]);
            return !error && touched[field];
        });
    }, [formData, touched, validateField]);
*/


    const isStepValid = useCallback((step) => {
        const fieldsToValidate = {
            0: ['firstName', 'lastName', 'email', 'phoneNumber', 'dateOfBirthString'],
            1: ['country', 'streetAddress', 'province', 'city', 'profession'],
            2: ['username', 'password', 'confirmPassword']
        };

        return fieldsToValidate[step].every(field => {
            const error = validateField(field, formData[field]);
            return !error && touched[field];
        });
    }, [formData, touched, validateField]);


    // Passage à l'étape suivante
    const handleNext = useCallback(() => {
        if (isStepValid(currentStep)) {
            setCurrentStep(prev => prev + 1);
        }
    }, [currentStep, isStepValid]);

    // Retour à l'étape précédente
    const handlePrevious = useCallback(() => {
        setCurrentStep(prev => prev - 1);
    }, []);

    // Soumission du formulaire
    const handleSubmit = useCallback(async (e, userService) => {
        e.preventDefault();
        if (!isStepValid(2)) return;

        // Vérification finale des espaces
        const finalErrors = {};
        let hasErrors = false;

        if (/\s/.test(formData.email)) {
            finalErrors.email = 'L\'email ne doit pas contenir d\'espaces';
            hasErrors = true;
        }

        if (/\s/.test(formData.username)) {
            finalErrors.username = 'Le nom d\'utilisateur ne doit pas contenir d\'espaces';
            hasErrors = true;
        }

        if (/\s/.test(formData.password)) {
            finalErrors.password = 'Le mot de passe ne doit pas contenir d\'espaces';
            hasErrors = true;
        }

        if (hasErrors) {
            setErrors(prev => ({ ...prev, ...finalErrors }));
            return;
        }

        setIsSubmitting(true);
        setIsLoading(true);
        try {
            // Préparation des données avec les champs en minuscules
            const submissionData = {
                ...formData,
                email: formData.email.toLowerCase(),
                username: formData.username.toLowerCase()
            };

            await userService.registerUser(submissionData);
            toast.success('Inscription réussie ! Redirection vers la page de connexion...');
            await new Promise(resolve => setTimeout(resolve, 2000));
            navigate('/login');
        } catch (error) {
            const errorMessage = error.response?.data?.message || "L'inscription a échoué. Veuillez réessayer.";
            toast.error(errorMessage);
            console.error(error);
        } finally {
            setIsLoading(false);
            setIsSubmitting(false);
        }
    }, [formData, isStepValid, navigate]);

    return {
        countries,
        provincesCanada,
        citiesCanada,
        currentStep,
        isLoading,
        isSubmitting,
        formData,
        errors,
        touched,
        showPassword,
        showConfirmPassword,
        setShowPassword,
        setShowConfirmPassword,
        handleInputChange,
        handleNext,
        handlePrevious,
        handleSubmit,
        isStepValid,
        handlePhoneChange
    };
};